module.exports = __webpack_public_path__ + "static/media/photo2-2.e3c198c1.jpg";